export const toInsightVariable = (insightId: string) =>
  `{insight['${insightId}']}`;
